import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { postReactivateAccount } from '@hungryroot/rest/api/reactivate_account/post';

export function useReactivateAccount(options?: { onSuccess: () => void }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await postReactivateAccount();
      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess: () => {
      // Update customer dashboard with active account status
      queryClient.invalidateQueries({ queryKey: ['get_customer_dashboard'] });
      queryClient.invalidateQueries({
        queryKey: ['Orders', 'get_customer_dashboard'],
      });
      queryClient.invalidateQueries({ queryKey: ['Customers'] });
      if (options?.onSuccess) {
        options.onSuccess();
      }
    },
  });
}
